// HOOKS
import { useState } from "react";

const DEFAULT_OPTIONS = [
  { id: 1, name: "default", value: "false", checked: false, label: "Default" },
];

const useMultiSelectStore = ({ defaultOptions = DEFAULT_OPTIONS }) => {
  const [options, setOptions] = useState(defaultOptions);

  const handleChange = (event) => {
    const { name, checked } = event?.target;
    console.log({ name, checked });
    const newOptions = options.map((option) =>
      option?.name === name ? { ...option, checked: checked } : option
    );
    setOptions(newOptions);
  };

  const handleReset = () => {
    setOptions(defaultOptions);
  };

  return { options, handleChange, handleReset };
};

export default useMultiSelectStore;
